<script>
  import { getContext } from 'svelte';
  import { format } from 'd3-format';

  import QuadTree from './QuadTree.svelte';

  let seriesColorNames = {'Long-Term Debt' : '#7198c8',
                         'Short-Term Debt' :'#f63'};


  const { data, width, xScale, yScale, config } = getContext('LayerCake');

  const commas = format(',');
  const titleCase = d => d.replace(/^\w/, w => w.toUpperCase());

  export let tooltipOffset = -30;
  export let dataset = undefined;
  export let formatTitle = d => d;
  export let formatKey = d => titleCase(d);
  export let formatValue = d => isNaN(+d) ? d : commas(d);
  export let seriesColors = d => d;


  const w = 175;
  const w2 = w / 2;
  let top = 0;

	/* --------------------------------------------
	 * Sort the keys by the highest value
	 */
  function sortResult(result) {
    // return result;
    if (Object.keys(result).length === 0) return [];
    const rows = Object.keys(result).filter(d => d !== 'year').map(key => {
      return {
        key,
        value: result[key]
      };
    }).sort((a, b) => b.value - a.value);
    return rows;
  }
</script>

<style>
	.tooltip {
		position: absolute;
		font-size: 13px;
		pointer-events: none;
		border: 1px solid #d3d3d3;
    /* box-shadow: 5px 5px 20px rgb(211, 211, 211, 0.5); */
		background: rgba(255, 255, 255, 1);
		transform: translate(-50%, -100%);
    padding: 5px;
    z-index: 15;
    pointer-events: none;
    font-family: 'Open Sans', sans-serif;
  }
  .line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 5px;
    border-left: 3px solid #d3d3d3;
    pointer-events: none;
  }
  .tooltip,
  .line {
    transition: left 250ms ease-out, top 250ms ease-out;
  }
  .title {
    font-weight: bold;
    text-align: center;
    font-size: 14px;
  }
  .key {
    color: #333;
  }

  .chip-circle {
    border-radius: 50%;
    display: inline-block;
    position: relative;
    width: 10px;
    height: 10px;
    background-color: #333;
  }
</style>

<QuadTree
  dataset={dataset || $data}
  xGetter={d => $xScale(d.year)}
  yGetter={d => $xScale(d.year)}
  y='x'
  let:x
  let:y
  let:visible
  let:found
  let:e

>
  {#if visible === true}
    <div
      style="left:{x}px;"
      class="line"></div>
    <div
      class="tooltip"
      style="
        width:{w}px;
        display: { visible ? 'block' : 'none' };
        top:{$yScale(sortResult(found)[0].value) - tooltipOffset}px;
        left:{Math.min(Math.max(w2, x), $width - w2)}px;"
      >
        <div class="title">{formatTitle(found.year)}</div>
        <hr style = "border-top: 3px solid #d3d3d3;">
        {#if found['Long-Term Debt'] > 1}
        {#if found['Long-Term Debt'] > 50000}
        <span style="margin: 0; font-size: 16px; font-weight: 800;">Total: ${formatValue(((found['Long-Term Debt'] + found['Short-Term Debt'])/1e9).toFixed(3))} B</span>
        {:else}
        <span style="margin: 0; font-size: 16px; font-weight: 800;">Total: ${formatValue(Math.round(found['Long-Term Debt'] + found['Short-Term Debt']))}</span>
        {/if}
        <hr style = "border-top: 1px solid #d3d3d3;">
        {#each sortResult(found) as row}
          <div class="key"><div class = "chip-circle" style="background-color:{seriesColorNames[row.key]}"></div> 
          <span class="key">{formatKey(row.key)}:</span> ${formatValue(Math.round(row.value))}</div>
        {/each}
        {:else}
        {#each sortResult(found) as row}
          <div class="key"><div class = "chip-circle" style="background-color:{seriesColorNames[row.key]}"></div> 
          <span class="key">{formatKey(row.key)}:</span> {(row.value * 100).toFixed(1)}%</div>
        {/each}
        {/if}
    </div>
  {/if}
</QuadTree>

